/**
 * Created by hp on 2017/7/25.
 */
const defaults = {
    dsListInitialized: false,
    dsDetailInitialized: false,
    dsShareInitialized: false,
    dsAcceptInitialized: false,
    showAddDialog: false
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'DISCOUNT_LIST_INIT':
            return {...state, dsListInitialized: true, ...action.payload};
        case 'DISCOUNT_LIST_DELETE':
            return {...state, ...action.payload};
        case 'DISCOUNT_LIST_ADD':
            return {...state, ...action.payload};
        case 'DISCOUNT_DETAIL_INIT':
            return {...state, dsDetailInitialized: true, ...action.payload};
        case 'DISCOUNT_DETAIL_UNMOUNT':
            return {...state, dsDetailInitialized: false};
        case 'DISCOUNT_SHARE_INIT':
            return {...state, dsShareInitialized: true, ...action.payload};
        case 'DISCOUNT_SHARE_UNMOUNT':
            return {...state, dsShareInitialized: false};
        case 'DISCOUNT_ACCEPT_INIT':
            return {...state, dsAcceptInitialized: true, ...action.payload};
        case 'DISCOUNT_ACCEPT_STATUS_SET':
            state.discountAccept.accept_status = 'can_use';
            return {...state, ...state.discountAccept};
        case 'DISCOUNT_SHOW_ADD_DIALOG':
            return {...state, showAddDialog: true};
        case 'DISCOUNT_HIDE_ADD_DIALOG':
            return {...state, showAddDialog: false};
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/discount.js